import { render, staticRenderFns } from "./VDataTableHistory.vue?vue&type=template&id=74981ede&scoped=true"
import script from "./VDataTableHistory.vue?vue&type=script&lang=js"
export * from "./VDataTableHistory.vue?vue&type=script&lang=js"
import style0 from "./VDataTableHistory.vue?vue&type=style&index=0&id=74981ede&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74981ede",
  null
  
)

export default component.exports